export enum AccountMeterScaleType {
    Day = 1,
    Night = 2,
    Main = 3,
    Peak = 4,
    HalfPeak = 5,
}

export const UnauthorizedAccountMeterScaleTypeDictionary: Record<string, AccountMeterScaleType> = {
    'День': 1,
    'Ночь': 2,
    'Основная': 3,
    'Пик': 4,
    'Полупик': 5,
};

export const AccountMeterScaleTypeDictionary: Record<AccountMeterScaleType, string> = {
    [AccountMeterScaleType.Day]: 'День',
    [AccountMeterScaleType.Night]: 'Ночь',
    [AccountMeterScaleType.Main]: 'Основная',
    [AccountMeterScaleType.Peak]: 'Пик',
    [AccountMeterScaleType.HalfPeak]: 'Полупик',
};
